import { createContext, useContext } from "react";

// Claim workspace actions (sign / unsign / note edit / recode). Null outside the workspace.
export const CwCtx = createContext(null);
export const useCw = () => useContext(CwCtx);
